/**
 * Is this session an admin account? (signup-invite-simple, migration 041)
 *
 * Decided by the server — `is_royale_admin()` checks the caller's session
 * against a server-only admin list — never by the display name, which anyone
 * can edit. Gates who is SHOWN Mark's Invite; the server separately refuses
 * an invite written by anyone else, so this answer is a display gate only.
 *
 * One call per auth session: the answer is memoised against the auth user
 * id, so a login on this device (a new session) asks again.
 */

import { authReady, getAuthUserId, supabase } from '../supabase';

let memo = { authUserId: null, promise: null };

export const isRoyaleAdmin = async () => {
  await authReady;
  const authUserId = getAuthUserId();
  if (!authUserId) return false;
  if (memo.authUserId !== authUserId || !memo.promise) {
    memo = {
      authUserId,
      promise: supabase.rpc('is_royale_admin').then(({ data, error }) => {
        if (error) {
          console.error('[ROYALE_ADMIN] is_royale_admin failed:', error.message);
          memo = { authUserId: null, promise: null }; // ask again next time
          return false; // not shown — the server would refuse the invite anyway
        }
        return data === true;
      }),
    };
  }
  return memo.promise;
};

/** Test seam: forget the memo. */
export const resetRoyaleAdminMemo = () => {
  memo = { authUserId: null, promise: null };
};
